export default function promiseMiddleware() {
    return (next) => (action) => {
        if (action && action.then) {
            action.then((result) => next(result));
        } else {
            next(action);
        }
    };
}
